// src/utils/api-helpers/PermissionsService.helpers.ts
// Helper to call permissions endpoints that are not generated (catalog)
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export interface PermissionCatalogEntry {
  id: string;
  code: string;
  module: string;
  menu: string;
  action: string;
  resource?: string;
  displayName: string;
  description?: string;
  isActive: boolean;
}

export class PermissionsServiceHelpers {
  /**
   * Get permission catalog
   */
  public static getCatalog(): Promise<PermissionCatalogEntry[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/permissions/catalog',
    }) as any;
  }
}
